export default "/_next/static/images/petition-share-3757b63a2e1ca42da7a3c50cc4268a0e.png";